export const CHANGE_CONTROL_PANEL = "CHANGE_CONTROL_PANEL";
export const CLEAN_CONTROL_PANEL = "CLEAN_CONTROL_PANEL";
export const TOGGLE_LEGEND = "TOGGLE_LEGEND";
